import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {UiService} from '../../../../services/ui.service';
import {Router} from '@angular/router';
import {Globals} from '../../../../globals';
import {CaseFormsService} from '../../case-forms.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatRadioChange} from '@angular/material/radio';
import {DataARClaimListModel} from '../../../ar/models/data-ar-claim-list';
import {ClaimViewComponent} from '../../../ar/claims/claim-view/claim-view.component';

export interface IClaimOptions {
  PatientId: string;
  isAllFees: number;
  isPrimaryInsurance: number;
  LOCID: string;
}
@Component({
  selector: 'app-check-out-ada-claim-dialog',
  templateUrl: './check-out-ada-claim-dialog.component.html',
  styleUrls: ['./check-out-ada-claim-dialog.component.scss']
})
export class CheckOutAdaClaimDialogComponent implements OnInit {
isPrimary: number = 1;
isAllFees: number = 1;
claimNotCheckedStatus = '00000208-1000-0000-0000-000000000001';


  constructor(private dialogRef: MatDialogRef<CheckOutAdaClaimDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public uiService: UiService,
              private router: Router,
              private globals: Globals,
              private caseService: CaseFormsService,
              private snackBar: MatSnackBar,
              private dialog: MatDialog) { }

  ngOnInit(): void {
  }
  createClaim(){
    // createClaimFromCheckOut
    const claimCreationObj: IClaimOptions =  {
      PatientId: this.globals.currentPatientId,
      isAllFees: this.isAllFees,
      isPrimaryInsurance: this.isPrimary,
      LOCID: this.globals.LOCID
    };
    return this.caseService.createClaimFromCheckOut(claimCreationObj).toPromise().then(
      res => {
        // this.router.navigateByUrl('/landing/claims');
        // this.showMessage('TDOx', 'opening claim ID: ' +  res.ARClaimID);
        const newClaim: DataARClaimListModel = new DataARClaimListModel();
        newClaim.ARClaimID = res.ARClaimID;
        newClaim.enumClaimStatusID = res.enumClaimStatusID;
        newClaim.enumClaimCheckStatusID = this.claimNotCheckedStatus;
        this.openClaim(newClaim);

        this.dialogRef.close();
      },
      msg => {
        this.showMessage('Warning', msg.error);
      }
    );
  }

  openClaim(item: DataARClaimListModel) {
    const config = new MatDialogConfig();
    config.width = '900px';
    config.height = '675px';
    config.data = {
      ARClaimID: item.ARClaimID,
      enumClaimStatusID: item.enumClaimStatusID,
      enumClaimCheckStatusID: item.enumClaimCheckStatusID,
    };
    config.panelClass = 'dialog';

    const reportViewer = this.dialog.open(ClaimViewComponent, config);

    /*reportViewer.afterClosed().subscribe(result => {
      this.arService.getAllClaims()
        .subscribe(response => {
            this.dataClaims = response;
            this.tdoTable.dataSource = this.dataClaims;
            this.tdoTable.updateData();
          },
          err => {
          });
    }, err => {
    });*/
  }






  radioInsuranceType(event: MatRadioChange) {
    event.value === 'Primary' ? this.isPrimary = 1 : this.isPrimary = 0;
  }
  radioAllFees(event: MatRadioChange) {
    event.value === 'AllFees' ? this.isAllFees = 1 : this.isAllFees = 0;
  }
  cancelClaim(){
    this.dialogRef.close();
  }
  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }
}
